import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { DeliveryPromotionBanner } from 'chemistry'
import { TranslateContext } from 'client/common/translator'

const DeliveryCategoriesBanner = ({ productDetails, lang, format }) => {
  const { deliveryPromotions } = productDetails
  const t = useContext(TranslateContext)
  const categories = deliveryPromotions[0].categories.map((c, i) => (
    <>
      <a href={`/c/${c.code}`} rel='noreferrer'>
        {c.name}
      </a>
      {i === deliveryPromotions[0].categories.length - 1 ? ' ' : ', '}{' '}
    </>
  ))

  const { categoryThreshold } = deliveryPromotions[0]
  const description = t('description_promotion_banner_text', { categoryThreshold })

  return (
    <DeliveryPromotionBanner
      description={
        <>
          {categories}
          {description}
        </>
      }
      lang={lang}
      format={format}
    />
  )
}

DeliveryCategoriesBanner.propTypes = {
  productDetails: PropTypes.shape({
    deliveryPromotions: PropTypes.shape([])
  }),
  lang: PropTypes.string,
  format: PropTypes.string
}

export default DeliveryCategoriesBanner
